export default "__VITE_ASSET__eaa1541b__"